import { POST } from "../../index";

export const queryReminderList = (param) => POST("/v1/MaintainMaterialController/selectMaintainCarList", param);
export const insertReminder = (param) => POST("/v1/MaintainMaterialController/insertMaterial", param);

export const queryOrderList = (param) => POST("/v1/MaintainMaterialController/selectMaterialList", param);
export const deleteMaterial = (param) => POST("/v1/MaintainMaterialController/deleteMaterial", param);

export const updateMaterial = (param) => POST("/v1/MaintainMaterialController/updateMaterial", param);

// export const exportMaterialData = (param) => POST("/v1/MaintainMaterialController/exportMaterialData", param);

